// Imports
import ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ from "../../node_modules/html-loader/dist/runtime/getUrl.js";
var ___HTML_LOADER_IMPORT_0___ = new URL("../images/icon-info.svg", import.meta.url);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<template>\n  <div class=\"flex gap-3 flex--align-start\">\n    <img style=\"padding-top: 4px; width: 18px; filter: invert(1)\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" />\n    <span class=\"attention-message attention-message--warning\"> ${message} </span>\n  </div>\n</template>\n";
// Exports
export default code;